const InformativeCalculationView = () => import("@views/public/informative-calculation/informative-calculation-view.vue");
import InformativeCalculation from "@views/public/informative-calculation/informative-calculation.vue";

export const informativeCalculationRoutes = [
    {
        component: InformativeCalculationView,
        name: "informativeCalculationHome",
        path: "informative",
        redirect: { name: "informativeCalculation" },
        children: [
            {
                component: InformativeCalculation,
                name: "informativeCalculation",
                path: "/izracun/:partner",
                props: true,
                meta: {
                    buttons: [
                        { name: "Print", action: "printCalculation", visible: true, disabled: false, navigateTo: undefined },
                        { name: "CalculateLimit", action: "toLimit", visible: true, disabled: false, navigateTo: undefined, class: "btn--primary-outline", openInNewWindow: true },
                    ],
                    navigation: {
                        toLimit: "limitCreate_home",
                    }
                }
            }
        ]
    },
];
